import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './MainSearch.scss';

const MainSearchForm = (props) => {
  const [search, setSearch] = useState('');
  const [showInput, setShowInput] = useState(false);

  const searchUpdated = (evt) => {
    if (evt.key !== "Enter") {
      const newState = evt.target.value;
      setSearch(newState);
    }
  }

  const navigateToProductos = (navigate) => {
    if (navigate && search) {  // Solo permite la navegación si hay texto en el input
      let searchBtn = document.getElementById("searchBtn");
      if (searchBtn && searchBtn.click) searchBtn.click();
    }
  }

  const toggleSearchInput = () => {
    setShowInput(!showInput);
  }

  useEffect(() => {
    setShowInput( window.matchMedia("(max-width: 600px)").matches );
  }, [])
  


  return (
    <div className={props.className}>
      <div className={`mainSearchForm mb-3 mb-sm-0 form-row align-items-center ${showInput && 'expanded'}`}>
        {/* Link oculto para la navegación */}
        <Link id="searchBtn" to={`/tienda/productos/${search !== "" ? `?search=${search}` : ""}`} />
        
        {/* Icono de lupa visible inicialmente */}
        {!showInput && (
          <div className="search-icon" onClick={toggleSearchInput}>
            <i className="fa fa-search" aria-hidden="true"></i>
          </div>
        )}

        {/* Input de búsqueda visible al hacer clic en la lupa */}
        {showInput && (
          <>
            <div className="col-9 col-sm-12 col-md-auto my-1">
              <input
                type="text"
                value={search}
                onChange={searchUpdated}
                onKeyDown={(evt) => navigateToProductos(evt.key === "Enter")}
                className={`form-control input-search ${showInput ? 'visible' : ''}`} // Agrega la clase "visible"
                placeholder="¿Qué estás buscando?"
              />
            </div>

            <div className="col-3 col-sm-12 col-md-auto my-1">
              <button 
                onClick={() => navigateToProductos(true)} 
                className="btn btn-success w-100"
                disabled={!search} // Deshabilita el botón si el input está vacío
              >
                BUSCAR
              </button>
            </div>

            {/* Botón para cerrar el input y volver al modo de icono de lupa */}
            <div className="close-icon d-none d-md-block" onClick={toggleSearchInput}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MainSearchForm;
